import { render, staticRenderFns } from "./select-price-tag.vue?vue&type=template&id=73951e5a&scoped=true&"
import script from "./select-price-tag.vue?vue&type=script&lang=js&"
export * from "./select-price-tag.vue?vue&type=script&lang=js&"
import style0 from "./select-price-tag.vue?vue&type=style&index=0&id=73951e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73951e5a",
  null
  
)

export default component.exports